import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import BackMethods from "../../back_component/BackMethods";
import img from "../../1.webp";

export default function FilteredEstablishmentsPage() {
    const navigate = useNavigate();
    const location = useLocation();
    const { backEnd_request } = BackMethods();

    // استخراج القيم من الرابط (Query Parameters)
    const queryParams = new URLSearchParams(location.search);
    const facilityType = queryParams.get("facilityType"); // نوع المنشأة (بقاليات...)
    const activityType = queryParams.get("activityType"); // نوع النشاط (أدوات منزلية...)
    const governorate = queryParams.get("governorate");
    const city = queryParams.get("city");

    const [establishments, setEstablishments] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [viewMode, setViewMode] = useState('table'); // افتراضي جدول كما طلبت

    const fetchFilteredData = async () => {
        setIsLoading(true);
        try {
            let endpoint = "";
            let params = { governorate };
            if (city) params.city = city;

            // تحديد النهاية الطرفية بناءً على نوع البحث
            if (facilityType) {
                endpoint = "/Establishments/by-facility";
                params.facilityType = facilityType;
            } else if (activityType) {
                endpoint = "/Establishments/by-activity";
                params.activityType = activityType;
            } else {
                endpoint = "/Establishments"; // الافتراضي
            }

            const res = await backEnd_request.get(endpoint, { params });

            // البيانات في JSON الجديد تأتي كمصفوفة مباشرة أو داخل data
            const data = res.data?.data || res.data || [];
            setEstablishments(data);
        } catch (error) {
            console.error("Fetch Error:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchFilteredData();
    }, [facilityType, activityType, governorate, city]);

    // --- مكون عرض الجدول (المعدل ليناسب البيانات الجديدة) ---
    const TableView = ({ data }) => (
        <div className="separated-table px-2">
            {data.map((est) => (
                <div key={est.establishmentId} className="table-row-card" onClick={() => navigate(`/admin/establishments/${est.fieldUID}`)}>
                    <div className="row align-items-center w-100 m-0 text-center text-md-end">
                        <div className="col-md-4 text-md-end mb-2 mb-md-0">
                            <span className="row-label">المنشأة</span>
                            <div className="fw-bold text-dark d-block text-truncate">{est.name}</div>
                            <small className="text-info">{est.facilityType || (est.activities?.[0]?.activityType)}</small>
                        </div>
                        <div className="col-md-3 border-start border-end mb-2 mb-md-0">
                            <span className="row-label">الموقع</span>
                            <div className="text-muted small">
                                {est.governorate} / {est.city}
                                {est.district && ` / ${est.district}`}
                            </div>
                        </div>
                        <div className="col-md-3 mb-2 mb-md-0">
                            <span className="row-label">العنوان التفصيلي</span>
                            <div className="text-muted x-small" style={{ fontSize: '0.7rem' }}>
                                {est.addressText || "غير محدد"}
                            </div>
                        </div>
                        <div className="col-md-2 text-start d-none d-md-block">
                            <button className="btn-go"><i className="bi bi-arrow-left"></i></button>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );

    return (
        <div className="dashboard-bg my-3 py-4 px-4" dir="rtl">
            <div className="container-fluid">
                {/* Header */}
                <div className="d-flex justify-content-between align-items-center mb-5 header-container flex-wrap gap-3">
                    <div>
                        <h4 className="fw-bold mb-0">
                            عرض حسب: {facilityType || activityType || "الكل"}
                        </h4>
                        <div className="text-muted small mt-1">
                            المنطقة: <span className="badge bg-secondary rounded-pill">{governorate} {city ? `- ${city}` : ""}</span>
                            {" | "} النتائج: <span className="badge bg-dark rounded-pill">{establishments.length}</span>
                        </div>
                    </div>

                    <div className="switcher-container shadow-sm">
                        <button className={viewMode === 'cards' ? 'active' : ''} onClick={() => setViewMode('cards')}><i className="bi bi-grid-3x3-gap"></i></button>
                        <button className={viewMode === 'table' ? 'active' : ''} onClick={() => setViewMode('table')}><i className="bi bi-list-ul"></i></button>
                    </div>
                </div>

                {isLoading ? (
                    <div className="text-center py-5"><div className="spinner-border text-info"></div></div>
                ) : (
                    <div className="row g-3">
                        {establishments.length > 0 ? (
                            viewMode === 'table' ? <TableView data={establishments} /> : <p>العرض ككروت (يمكنك إضافة CardView هنا)</p>
                        ) : (
                            <div className="text-center py-5 text-muted">لا توجد منشآت مطابقة للبحث</div>
                        )}
                    </div>
                )}
            </div>

            {/* سنستخدم نفس الـ CSS الخاص بك مع تعديلات طفيفة */}
            <style>{`
                .dashboard-bg { background-color: #f0f2f5; min-height: 100vh; font-family: 'Cairo', sans-serif; }
                .table-row-card { background: #fff; border-radius: 16px; padding: 15px 20px; margin-bottom: 12px; display: flex; align-items: center; transition: 0.3s; border: 1px solid #e9ecef; cursor: pointer; }
                .table-row-card:hover { transform: translateX(5px); border-color: #0dcaf0; box-shadow: 0 5px 15px rgba(0,0,0,0.05); }
                .row-label { display: block; font-size: 0.65rem; color: #adb5bd; font-weight: 700; margin-bottom: 2px; }
                .switcher-container { background: #fff; border-radius: 12px; padding: 4px; display: flex; border: 1px solid #dee2e6; }
                .switcher-container button { border: none; background: transparent; padding: 6px 16px; border-radius: 10px; color: #6c757d; }
                .switcher-container button.active { background: #0dcaf0; color: #fff; }
                .btn-go { width: 32px; height: 32px; border-radius: 8px; border: none; background: #f8f9fa; color: #adb5bd; }
                .x-small { line-height: 1.2; }
            `}</style>
        </div>
    );
}